import React, { useState, useEffect, useCallback } from 'react';
import { TextInput } from '@mantine/core';

const classNames = {
  input: 'max-h-[24px] p-0 bg-white rounded-[2px] text-[#626262] border-transparent focus:border-primary text-center',
};

export const EditableText = React.memo((props) => {
  const { name, disabled, onChange, className, value = '' } = props;
  const [key, setKey] = useState(value);
  const [editing, setEditing] = useState(false);
  const innerValue = !!Number(value) || Number(value) === 0 ? value : '';
  const handleClick = useCallback(() => {
    setEditing(true);
  }, []);

  useEffect(() => {
    setKey(innerValue);
  }, [innerValue]);

  const handleBlur = useCallback(
    (e) => {
      setEditing(false);
      onChange?.(e.currentTarget.value, name);
      setKey(e.currentTarget.value);
    },
    [name, onChange],
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        setEditing(false);
        onChange?.(e.currentTarget.value, name);
        setKey(e.currentTarget.value);
      }
    },
    [name, onChange],
  );

  return (
    <div className={`${className} flex items-center justify-center`}>
      <TextInput
        size="xxs"
        key={key}
        tabIndex={1}
        styles={{ input: { background: 'transparent' } }}
        readOnly={disabled || !editing}
        className={`flex-grow`}
        classNames={classNames}
        defaultValue={innerValue}
        onClick={handleClick}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
});
